import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Divider, FullRow, TextButton, useIntentBehavior, useOverlayContext } from 'seagull';
import { Download, UserAdd } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useClientFlowPdfDownload } from '~/client-flow/hooks/useClientFlowPdfDownload';
import InviteOrEditMemberModal from '~/components/InviteOrEditMemberModal';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import { relationshipModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import styles from './CoverPageHeader.module.scss';
export const GetCoverPageHeaderTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const CoverPageHeader = (param)=>{
    let { testId, relationship } = param;
    const { t: coverTexts } = useLocaleKeys('clientFlow.coverPage');
    const { CoverPageHeaderTestIds } = useMemo(()=>GetCoverPageHeaderTID(testId), [
        testId
    ]);
    const { showModal } = useOverlayContext();
    const { downloadPdf } = useClientFlowPdfDownload();
    const userId = useStore(selectors.user.id);
    const { getDisabled } = useIntentBehavior();
    const isNonSignatory = relationshipModel.isReviewer(relationship, userId) || relationshipModel.isSignatory(relationship, userId);
    const isInviteDisabled = isNonSignatory || getDisabled(Intent.InviteTeamMember);
    const onDownloadPdf = ()=>{
        downloadPdf(relationship);
    };
    const openInviteMemberModal = ()=>{
        showModal({
            biName: 'invite_or_edit_member_modal',
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(InviteOrEditMemberModal, {
                    isResponsive: true,
                    onClose: dismissModal
                });
            }
        });
    };
    return /*#__PURE__*/ _jsx(FullRow, {
        justifyContent: "end",
        testId: CoverPageHeaderTestIds.Root(),
        className: styles.root,
        children: /*#__PURE__*/ _jsxs(Box, {
            className: styles.container,
            children: [
                /*#__PURE__*/ _jsx(TextButton, {
                    testId: CoverPageHeaderTestIds.DownloadPdf(),
                    prefixIcon: /*#__PURE__*/ _jsx(Download, {}),
                    underline: "none",
                    onClick: onDownloadPdf,
                    weight: "normal",
                    children: coverTexts.downloadPdf()
                }),
                !isInviteDisabled && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Divider, {
                            orientation: "vertical",
                            margin: 16
                        }),
                        /*#__PURE__*/ _jsx(TextButton, {
                            testId: CoverPageHeaderTestIds.InviteMember(),
                            prefixIcon: /*#__PURE__*/ _jsx(UserAdd, {}),
                            underline: "none",
                            onClick: openInviteMemberModal,
                            weight: "normal",
                            children: coverTexts.inviteTeamMember()
                        })
                    ]
                })
            ]
        })
    });
};
